
<script>
import request from "./request.vue";
import session from "./session.vue";
import env from "../config/prod.env.js";

// const local = 'http://localhost:3000/api'

export default {

  search: async function(data, column = '', order = '', page = 1, limit = 0, filter = '') {
    if (data && data.length > 0) data.split(' ').join('%20');

    try {
      const resp =  await request.send(`${env.ROOT_API}/vehicles/vehiclespart?query=${data}&page=${page}&limit=${limit}&orderBy=${column}%20${order}&${filter}`, {}, false, 'get');
      return resp;
    } catch (error) {
      console.log(error)
    }
  },
  getFilters: async function(data = '', filter = '') {
    if (data && data.length > 0) data.split(' ').join('%20');
    try {
      const resp =  await request.send(`${env.ROOT_API}/vehicles/vehiclesFilters?query=${data}&${filter}`, {}, false, 'get');
      return resp;
    } catch (error) {
      console.log(error)
    }
  },
  getAllFilters: async function() {
    try {
      const resp =  await request.send(`${env.ROOT_API}/vehicles/vehiclesAllFilters`, {}, false, 'get');
      return resp;
    } catch (error) {
      console.log(error)
    }
  },
  getWithFilters: async function(column = '', order = '', page = 1, limit = 0, filter = '') {
    try {
      const resp =  await request.send(`${env.ROOT_API}/vehicles/vehiclesWithFilters?page=${page}&limit=${limit}&orderBy=${column}%20${order}&${filter}`, {}, false, 'get');
      return resp;
    } catch (error) {
      console.log(error)
    }
  },
  getManufacturers: async function(data) {
    try {
      const resp =  await request.send(`${env.ROOT_API}/vehicle_manufacturers/${data ? data : ''}`, {}, false, 'get');
      return resp;
    } catch (error) {
      console.log(error)
    }
  },
  getModels: async function(){
    try {
      const resp =  await request.send(` ${env.ROOT_API}/vehicle_models`, {}, false, 'get');
      return resp;
    } catch (error) {
      console.log(error)
    }
  },
  getById: async function(id) {
    try {
      const resp =  await request.send(`${env.ROOT_API}/vehicles/${id}`, {}, false, 'get');
      return resp;
    } catch (error) {
      console.log(error)
    }
  },
  getParts: async function(id){
    try {
      const resp =  await request.send(`${env.ROOT_API}/vehicles/${id}/vehicleParts`, {}, false, 'get');
      return resp;
    } catch (error) {
      console.log(error)
    }
  },
  getLines: async function(id){
    try {
      const resp =  await request.send(`${env.ROOT_API}/vehicle_lines/${id}`, {}, false, 'get');
      return resp;
    } catch (error) {
      console.log(error)
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/api/vehicle.vue